import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getManagers,
  managerListSuccessful,
  managerAddSuccessful,
  firmListSuccessful,
} from "./managerSlice";
import { Modal } from "antd";
import { RiCheckboxCircleLine, RiAlertLine } from "react-icons/ri";
import { postAdd, getParamsList, getList, postEdit, postDelete } from "../../../helpers/Helper";

function* fetchManagerList({ payload }) {
  var params = {};
  for (const k in payload) {
    if (Object.hasOwnProperty.call(payload, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = payload.sortOrder + payload.currentSort;
      } else if (payload[k] != "" && k != null && k != "no_of_pages") {
        params[k] = payload[k];
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/managers/", params);
    yield put(managerListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddManager({ payload }) {
  try {
    const obj = { name: payload.name, firm_id: payload.firm_id };
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/managers/", obj);
      if (response.status === 201) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Manager Added Successfully!</p>,
        });
        yield put(getManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to add Manager!</p>,
        });
      }
    } else {
      const response = yield call(postEdit, "/masters/managers/" + payload.id, obj);
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Manager Updated Successfully!</p>,
        });
        yield put(getManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to update Manager!</p>,
        });
      }
    }
    yield put(managerAddSuccessful());
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* DeleteManager({ payload }) {
  try {
    const response = yield call(postDelete, "/masters/managers/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Manager deleted!</p>,
      });
      yield put(getManagers({ page: 1, search: "", page_size: 10 }));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchFirmList() {
  try {
    const response = yield call(getList, "/masters/mini/firm/");
    yield put(firmListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* ManagerSaga() {
  yield all([
    fork(function* () { yield takeEvery("manager/getManagers", fetchManagerList); }),
    fork(function* () { yield takeEvery("manager/managerAdd", AddManager); }),
    fork(function* () { yield takeEvery("manager/managerDelete", DeleteManager); }),
    fork(function* () { yield takeEvery("manager/getFirmList", fetchFirmList); }),
  ]);
}

export default ManagerSaga;
